<template>
	<div class="tabsMain">
		<!-- Main Header -->
		<div class="tabs_header">
			<!-- Generate selector that is currently selected -->
			<!--<div class="tabs_selectedbox" v-for="(tabs, index) in tabsItems" v-if="tabsCurrent == index">
				<div class="tabsSelectors tabsActive">{{tabs.title}}</div>
			</div>-->
			<!-- Generate the rest which are not selected -->
			<div class="tabsSelectorbox" ref="tabsSelectorbox">
				<div v-for="(tabs, tabsindex) in tabsItems" v-bind:key="tabsindex"
					:class="['tabsSelectors', { tabsDisabled: !tabs.enabled }, { tabsActive: tabsCurrent == tabsindex }]"
					v-on:click="tabs.enabled? setSelected(tabsindex) : '' ">
					<div class="tabsShadowBox" v-if="tabsCurrent == tabsindex"></div>
					{{tabs.title}}
				</div>
			</div>
		</div>

		<!-- Main Body -->
		<div class="tabsBody">
			<div class="tabsContent"
				v-for="(page, pg) in tabsItems"
				v-bind:key="pg"
				:style="[ tabsCurrent == pg ? { 'opacity' : '1', 'zIndex' : '1'  } : { 'opacity' : '0', 'zIndex' : '-1' } ]">
				<div class="tabsColumns"
					v-for="(column, col) in page.items"
					v-bind:key="col"
					:style="[ (page.items.length <= 1) ? '' : (col > 0 && col < page.items.length - 1) ? { 'margin' : '0 5px 0 5px', width: `calc(100% / ${page.items.length})` } : (col == page.items.length - 1) ? { 'margin' : '0 0 0 5px', width: `calc(100% / ${page.items.length})` } : { 'margin' : '0 5px 0 0', width: `calc(100% / ${page.items.length})` }  ]">
					<div :class="[ 'tabsRows',  {tabsGooglemap: (rows.type == 'googlemap') }, {tabsTabulator: (rows.type == 'tabulator') } ]"
						v-for="(rows, row) in column"
						v-bind:key="row">
						<div v-for="(data, index) in (Array.isArray(rows) ? rows : [rows])"
							v-bind:key="index"
							:style="[ (rows.length == null) ? '' : (index > 0 && index < rows.length - 1) ? { 'margin' : '0 3px 0 3px' } : (index == rows.length - 1) ? { 'margin' : '0 0 0 3px' } : { 'margin' : '0 3px 0 0' } ]"
							:class="[ 'tabsItems', { tabsCompact: (data.type == 'button') } ]">
							<div v-if="data.type == 'string'">{{data.string}}</div>
							<button class="tabsButton"
								v-if="data.type == 'button'"
								v-on:click="tabButtonclick(data.method)">
								<img class="tabsButtonImage"
									:src="data.img == '' ? '' : require('@/assets/' + data.img)"
									v-if="data.img != null && data.img != ''" />
								<div>{{data.string}}</div>
							</button>
							<Input v-if="data.type == 'input'"
								:placeholder="data.placeholder"
								:textAlign="data.textAlign"
								:textType="data.textType"
								:inputValue.sync="data.inputValue"
								:isDisabled="data.isDisabled"
								:showError="data.showError"
								:errorMessage="data.errorMessage"
								:isRequired="data.isRequired"
								:borderWidth="data.borderWidth" />
							<Inputquery v-if="data.type == 'inputquery'"
								:items="data.items"
								:placeholder="data.placeholder"
								:descKey="data.descKey"
								:search.sync="data.search" />
							<Dropdown v-if="data.type == 'dropdown'"
								@selected="dropdownSelected(data.selectedItem, data.selectedObject, data.method)"
								:items="data.items"
								:itemKey="data.itemKey"
								:placeholder="data.placeholder"
								:textAlign="data.textAlign"
								:selectedItem.sync="data.selectedItem"
								:selectedObject.sync="data.selectedObject"
								:isDisabled="data.isDisabled"
								:firstRowIsType="data.firstRowIsType"
								:borderWidth="data.borderWidth"
								:search.sync="data.search"/>
							<Checkbox v-if="data.type == 'checkbox'"
								@checkBoxClicked="checkboxChecked(data.isChecked, data.method)"
								:isChecked.sync="data.isChecked"
								:title="data.title" />
							<Datetime v-if="data.type == 'datetime'"
								:value="data.value"
								:showTime="data.showTime"
								:defaultTime="data.defaultTime"
								:maxDate="data.maxDate"
								:minDate="data.minDate"
								:selectedDate="data.selectedDate"/>
							<Googlemap v-if="data.type == 'googlemap'"
								@drag="mapDrag"
								@dragend="mapDragend"
								@dragstart="mapDragstart"
								@polyDragend="mapPolyDragend"
								@polyPathUpdate="mapPolyPathUpdate"
								:info="data.info"
								:center="data.center"
								:zoom="data.zoom"
								:fitBounds="data.fitBounds"
								:direction_route="data.direction_route"
								:marker_list="data.marker_list"
								:polygon="data.polygon" />
							<Tabulator v-if="data.type == 'tabulator'"
								ref="tabulators"
								class="tabsTabulatorComp"
								@rowSelected="tabulatorRowSelected"
								@rowDblClick="tabulatorRowDblClick"
								@cellButtonClick="tabulatorCellButtonClick"
								:tableTitle="data.tableTitle"
								:tableData="data.tableData"
								:selectedRow="data.selectedRow"
								:multiSelect="data.multiSelect"
								:tableDisabled="data.tableDisabled"
								:headerDisabled="data.headerDisabled"
								:rowFormatter="data.rowFormatter"
								:currentPage="data.currentPage"
								:currentRowSize="data.currentRowSize"
								:additionalColumn="data.additionalColumn"
								:frozenColumn="data.frozenColumn"
								:tableID="data.tableID" />
							<ProgressBar v-if="data.type == 'progressbar'"
								:title="data.title"
								:percentage="data.percentage" />
							<RemarksBox v-if="data.type == 'remarksbox'"
								:title="data.title"
								:text="data.text"
								:maxLength="data.maxLength" />
							<ItemListing v-if="data.type == 'itemlisting'" :title="data.title" :items="data.items"></ItemListing>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--<button @click="getdata">Get tabledata</button>-->
	</div>
</template>

<script>
/* eslint-disable */
import Input from "@/components/Input.vue";
import Inputquery from "@/components/InputQuery.vue";
import Dropdown from "@/components/Dropdown.vue";
import Checkbox from "@/components/CheckBox.vue";
import Datetime from "@/components/DateTimePicker.vue";
import Googlemap from "@/components/GoogleMap.vue";
import Tabulator from "@/components/Tabulator.vue";
import ProgressBar from "@/components/ProgressBar.vue";
import RemarksBox from "@/components/RemarksBox.vue";
import ItemListing from "@/components/ItemListing.vue";

export default { // OBSOLETE COMPONENT (Use Tab.vue instead)
	components: {
		Input, Inputquery, Dropdown, Checkbox, Datetime, Googlemap, Tabulator, ProgressBar, RemarksBox, ItemListing
	},
	props: {
		// Tabulator props (May not be in use after the ID update on Tabulator)
		tabulatorData: { type: Array, default: function () { return []; } },
		tabulatorNumber: { type: Number, default: 0 },
		tabsCurrent: { type: Number, default: 0 },
		tabulatorHeight: { type: Number, default: 200 },

		/*------------------------------------------------------------------------------------------------------------------------------------------------------------------------
				Example of tabs_items

				tabs_items: return [
				{
					title: 'Selector1', enabled: true, items: [
						[
							{Item1},
							[
								{Item2},
								{Item3},
							],
						],
					]
				},

				----------------------- EACH object in the tabs_items is ONE TAB (as in the selectors)
				----------------------- In the object, there is an 'items' key which has to hold the format as shown above
				----------------------- In 'items', ALL items (even if one column) MUST be placed in an array
				----------------------- In the array, objects or arrays of objects can be passed in
				----------------------- Objects will occupy a single row while objects in an array will be placed side by side.
				]
		------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

		// Public Properties
		// Selector props
		tabsItems: { type: Array, default: function () { return []; } }

		// Events
		// @tabButtonclick - fired when a button is clicked, will return method name (please handle on your end)
		// @dropdownSelected - fired when item is selected in dropdown
		// @checkboxChecked - fired when a checkbox is clicked
		// @mapDrag - fired when a marker is being dragged
		// @mapDragend - fired when a marker is dropped (after dragging)
		// @mapDragstart - fired when beginning to drag (not to be confused with click)
		// @tabulatorRowSelected - fired when a row on tabulator is clicked
		// @tabulatorRowDblClick - fired when a row in tabulator is double clicked
		// @tabulatorCellButtonClick - fired when a cell in tabulator is clicked
	},
	mounted() {
		this.setDefaultSelected();

    this.$nextTick(() => {
			var allTabulator = document.getElementsByClassName('tabulator-tableHolder');
			for (var i = 0; i < allTabulator.length; i++) {
				allTabulator[i].style.height = `${this.tabulatorHeight}px`;
			}
    });
	},
	methods: {
		getdata: function () {
			console.log(this.tabulatorData);
		},
		setSelected: function (index) {
			this.tabsCurrent = index;
		},
		setDefaultSelected: function () {
			for (var i = 0; i < this.tabsItems.length; i++) {
				if (this.tabsItems[i].enabled) {
					this.tabsCurrent = i;
					break;
				}
			}
		},
		settabulatordata: function () {
			for (var page in this.tabsItems) {
				for (var col in this.tabsItems[page].items) {
					for (var rows in this.tabsItems[page].items[col]) {
						for (var data in Array.isArray(
							this.tabsItems[page].items[col][rows]
						)
							? this.tabsItems[page].items[col][rows]
							: [this.tabsItems[page].items[col][rows]]) {
							var object = (Array.isArray(this.tabsItems[page].items[col][rows])
								? this.tabsItems[page].items[col][rows]
								: [this.tabsItems[page].items[col][rows]])[data];
							if (object.type == "tabulator") {
								this[object.tableTitle] = object.tableData;
								console.log(this["Table 1"]);
							}
						}
					}
					//console.log(Array.isArray(this.tabsItems[page].items[col][rows]) ? this.tabsItems[page].items[col][rows] : [this.tabsItems[page].items[col][rows]]);
					//console.log((Array.isArray(this.tabsItems[page].items[col][rows]) ? this.tabsItems[page].items[col][rows] : [this.tabsItems[page].items[col][rows]])[data].type);
				}
			}
		},
		//Tabs events
		tabButtonclick: function (method) {
			//Fired when a button is clicked
			//@args Returns method name (please handle on your end)
			this.$emit("tabButtonclick", method);
		},
		dropdownSelected: function (i, o, m) {
			//Fired when item is selected in dropdown
			// @arg Returns checkdown value (truth/false)
			this.$emit("dropdownSelected", i, o, m);
		},
		checkboxChecked: function (checkbox, method) {
			//Fired when a checkbox is clicked
			// @arg Returns truth/false
			this.$emit("checkboxChecked", checkbox, method);
		},
		//Map event
		mapDrag: function (marker) {
			// Fired when a marker is being dragged
			// @arg Returns marker object
			this.$emit("mapDrag", marker);
		},
		mapDragend: function (marker) {
			// Fired when a marker is dropped (after dragging)
			// @arg Returns marker object
			this.$emit("mapDragend", marker);
		},
		mapDragstart: function (marker) {
			// Fired when beginning to drag (not to be confused with click)
			// @arg Returns marker object
			this.$emit("mapDragstart", marker);
		},
		mapPolyDragend: function (polygon) {
			// Fired when a polygon is dropped (not to be confused with click)
			// @arg Returns polygon object
			this.$emit('mapPolyDragend', polygon);
		},
		mapPolyPathUpdate: function (polyPaths) {
			// Fired when a polygon is updated
			// @arg Returns list of coodinate objects
			this.$emit('mapPolyPathUpdate', polyPaths);
		},
		//Tabulator event
		tabulatorRowSelected: function (tabulatordata) {
			this.$emit("tabulatorRowSelected", tabulatordata);
		},
		tabulatorRowDblClick: function (tabulatordata) {
			this.$emit("tabulatorRowDblClick", tabulatordata);
		},
		tabulatorCellButtonClick: function (tabulatordata) {
			this.$emit("tabulatorCellButtonClick", tabulatordata);
		}
	},
	watch: {
		tabsItems: {
			deep: true,
			handler() {
				console.log('tabsitem changed');
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import "@/css/all.scss";
/* Selector Colours */
$tabs_selectorbackground: #e9ecef;
$tabs_selectorborder: #00000055;
$tabs_selectorhoverbackground: #edf2f5;
$tabs_selectorhoverborder: #00000066;
/* Selector Active Colours */
$tabsActivebackground: #ffffff;
/* Selector Disabled Colours */
$tabsDisabledbackground: #00000088;
/* Body Colours */
$tabsBodybackground: #ffffff;

* {
	padding: 0;
	margin: 0;
	font-size: 12px;
	box-sizing: border-box;
}

.tabsMain {
	width: 100%;
	height: 100%;
	padding: 1%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	z-index: 255;
}

.tabs_header {
	width: 100%;
	height: 30px;
	min-height: 30px;
	display: flex;
	align-items: flex-end;
	justify-content: space-between;
	z-index: 1;
}

.tabsSelectorbox {
	width: 100%;
	height: 100%;
	display: flex;
	align-items: flex-end;
	justify-content: flex-start;
}

.tabsSelectors {
	width: 100%;
	height: 90%;
	padding: 0 0 2px 0;
	font-size: 12px;
	line-height: 90%;
	position: relative;
	text-align: center;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: inset 0 -3px 5px -3px;
	border: solid 1px;
	border-bottom: none;
	border-radius: 5px 5px 0 0;
	-webkit-user-select: none; /* Safari */
	-ms-user-select: none; /* IE 10+ and Edge */
	user-select: none; /* Standard syntax */
	cursor: pointer;
	z-index: 2;
	/* Colours */
	background-color: $tabs_selectorbackground;
	border-color: $tabs_selectorborder;
}

	.tabsSelectors:hover {
		/* Colours */
		background-color: $tabs_selectorhoverbackground;
		border-color: $tabs_selectorhoverborder;
	}

.tabsActive {
	height: 100%;
	padding: 0 5px 0 5px;
	font-size: 14px;
	line-height: 14px;
	box-shadow: 0 0 5px;
	border-radius: 5px 5px 0 0;
	border: none;
	cursor: default;
	position: relative;
	z-index: 5;
	/* Colours */
	background-color: $tabsActivebackground;
}

	.tabsActive:hover {
		/* Colours */
		background-color: $tabsActivebackground;
	}

.tabsShadowBox {
	width: 100%;
	height: 100%;
	top: 20px;
	left: 0;
	position: absolute;
	z-index: -1;
	background-color: $tabsActivebackground;
}

.tabsDisabled {
	height: 80%;
	cursor: default;
	/* Colours */
	background-color: $tabsDisabledbackground;
}

	.tabsDisabled:hover {
		/* Colours */
		background-color: $tabsDisabledbackground;
	}

.tabsBody {
	width: 100%;
	height: 100%;
	flex: 1;
	position: relative;
	display: flex;
	align-items: flex-start;
	overflow-y: auto;
	justify-content: center;
	box-shadow: 0 0 5px;
	/* Colours */
	background-color: $tabsBodybackground;
	
}

.tabsContent {
	width: 100%;
	padding: 1%;
	position: absolute;
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
}

.tabsColumns {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
}

.tabsRows {
	width: 100%;
	min-height: 25px;
	margin: 3px 0 3px 0;
	display: flex;
	align-items: center;
	justify-content: flex-start;
}

.tabsItems {
	width: 100%;
	height: 100%;
	min-height: 25px;
	display: flex;
	align-items: center;
	justify-content: flex-start;
}

.tabsCompact {
	width: auto;
}

.tabsButton {
	width: 100%;
	height: 35px;
	padding: 2.5px 10px 2.5px 10px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.tabsButtonImage {
	width: 30px;
	height: 30px;
	margin: 0 5px 0 0;
}

.tabsGooglemap {
	flex: 1;
}

.tabsTabulator {
	flex: 1;
	position: relative;
}

.tabsTabulatorComp {
	width: 100%;
	height: 100%;
	position: static;
	display: flex;
	flex-direction: column;
}

/* Other components */
</style>
